import isNil from 'lodash/isNil';

import { CustomNumberFormatProps } from '../../NewInput/NewInput';
import { formatDates, formatShortDates, removeFormatting } from './dateMask';

const GUIDE = '_';

export const isAllowedCallback = (props): CustomNumberFormatProps['isAllowed'] => ({ value }) =>
  isNil(props.maxValue) || value === '-' || value <= props.maxValue;

export const getMask = (mask, props?) => {
  if (mask === 'ssn') {
    return { mask: GUIDE, format: '###-##-####' };
  }
  if (mask === 'ein') {
    return { mask: GUIDE, format: '##-#######' };
  }
  if (mask === 'zipcode') {
    return { mask: GUIDE, format: '#####' };
  }
  if (mask === 'phone') {
    return { mask: GUIDE, format: '(###) ###-####' };
  }
  if (mask === 'date') {
    return { mask: GUIDE, format: formatDates, removeFormatting };
  }
  if (mask === 'short-date') {
    return { mask: GUIDE, format: formatShortDates, removeFormatting };
  }
  if (mask && typeof mask === 'object') {
    return {
      ...mask,
      prefix: '',
      suffix: '',
    };
  }
  if (mask === 'integer') {
    return {
      prefix: '',
      suffix: '',
      thousandSeparator: ',',
      decimalScale: 0,
      allowNegative: true,
      isNumericString: true,
      isAllowed: isAllowedCallback(props),
    };
  }
  if (mask === 'decimal') {
    return {
      prefix: '',
      suffix: '',
      decimalSeparator: '.',
      thousandSeparator: ',',
      decimalScale: 2,
      allowNegative: true,
      isNumericString: true,
      fixedDecimalScale: true,
      isAllowed: isAllowedCallback(props),
    };
  }
  if (mask) {
    return { mask: GUIDE, format: mask };
  }
  return false;
};
